import React, { Component } from 'react';
import './KPI3.css';

import FormFieldCheckbox from '@acri-tools/react-tools/components/FormFieldCheckbox/FormFieldCheckbox';
import KPIs from '../KPIs';
// import { download_performance, query_performance, unavailability } from './data';
import moment from 'moment';
import { getDateTimeString } from '@acri-tools/react-tools/utils/date';

import Chart from 'chart.js';
import { Line } from 'react-chartjs-2';
import * as zoomPlugin from 'chartjs-plugin-zoom';
import { complete_bar_data_stop, default_options } from '../../../_utils/graphs';
import request from '@acri-tools/react-tools/utils/request';
import { API_URL } from '../../../_utils/config';
import { axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import KPITable from '../../../components/KPITable/KPITable';
import { date_timezone_compensated, get_month_dates, is_on_kpi_page, update_kpi_url } from '../../../_utils/kpi';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { to_local_iso_string } from '../../../_utils/date';
import { load_product_types } from '../../../_utils/product_types';
import KPIRefreshOverlay from '../../../components/KPIRefreshOverlay/KPIRefreshOverlay';
Chart.plugins.register(zoomPlugin);

interface Props {
    // REDUX
    kpi?:any
}
interface State {
    refreshing: boolean
    loading: boolean
    startDate: string
    stopDate: string
    updateStartDate: string
    updateStopDate: string
    base_startDate?: string
    base_stopDate?: string

    types?: any,

    unavailability: boolean
    downloadPerformance: boolean
    queryPerformance: boolean

    unavailability_data?: any,
    downloadPerformance_data?: any,
    queryPerformance_data?: any

    drag_mode?: boolean

    // export
    json_format: boolean
}


/**
 * 1. KPIS SELECT
 * 2. KPI Status select (unav, download, query)
 * 3. Graph 1 graph er selected
 *      unav 1 or 0 bar like
 *      download & quary normal line graph
 */

class KPI3 extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
            refreshing: false,
            json_format: false,
            unavailability: true,
            downloadPerformance: true,
            queryPerformance: true,
            ...this.default_values(true)
        }
    }
    default_values = (set_base?:boolean) => {
        return {
            ...get_month_dates( this.state, set_base )
            // startDate: `${today.getFullYear()}-${today.getMonth().toString().padStart(2, '0')}-01T00:00:00`,
            // stopDate: getDateTimeString(today, true),
        }
    }
    async componentDidMount() {
        this.fetch_type_data()
        this.fetch_data(true)
    }

    async componentDidUpdate(prevProps:Props) {
        if(prevProps.kpi?.refresh !== this.props.kpi?.refresh){
            await this.setState({
                ...this.default_values(true)
            })
            if(is_on_kpi_page(3)){
                this.update_url()
            }
            this.fetch_data(true)
        }
    }
    fetch_type_data = async() => {
        try {
            let res = await request(`${API_URL}/api/v1/distribution_types`,{ method:'get' })
            let types:any = {};
            res.data.value.forEach((t:any)=>{
                types[t.name] = t;
            })
            this.setState({ types });
        }
        catch (e) {
            axiosErrorHandler( e, { 
                functionName: 'fetch_type_data'
            })
        }
    }

    fetch_data = async(refresh?:boolean) => {
        if(refresh) this.setState({ refreshing: true, loading:true });
        else this.setState({ loading:true });
        try {
            let promises = [];
            if(this.state.unavailability)
                promises.push(this.fetch_service_data('unavailability'))
            if(this.state.downloadPerformance)
                promises.push(this.fetch_service_data('downloadPerformance'))
            if(this.state.queryPerformance)
                promises.push(this.fetch_service_data('queryPerformance'))
            
            await Promise.all(promises);
        }
        catch (e) {
        }
        finally {
            // this.setState({ loading: false })
            if(refresh) this.setState({ refreshing: false, loading:false });
            else this.setState({ loading:false });
        }
    }
    fetch_service_data = async(service:'unavailability'|'downloadPerformance'|'queryPerformance') => {
        try {
            let res = await request(`${API_URL}/api/v1/distribution`,{
                method:'get',
                responseType:'json',
                serializer:'json',
                params:{
                    orderby:'date_time DESC',
                    limit: 4500,
                    filter: `type eq '${service === 'unavailability' ? 'unavailability' : service === 'downloadPerformance' ? 'download performance' : 'query performance'  }'
                        and date_time ge '${this.state.startDate}' and date_time le '${this.state.stopDate}'`
                }
            })
            let update:any = {};
            update[`${service}_data`] = res.data.value;
            this.setState(update);
        }
        catch (e) {
            axiosErrorHandler( e, { 
                functionName: 'fetch_kpi_data'
            })
        }
    }


    applyChanges = async() =>{
        await this.setState({
            startDate: this.state.updateStartDate,
            stopDate: this.state.updateStopDate
        })
        this.update_url()
        this.fetch_data()
    }
    reset = async() => {
        await this.setState({
            ...this.default_values()
        })
        this.fetch_data(true)
    }

    render() {
        let _state: any = this.state;
        return (
            <KPIs
                title="PRIP Service Availability​"
            >
                <div className="row-2">
                    <div className="row-2">
                        <div className="form-field">
                            <label>Start Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStartDate}
                                onChange={(e) => { this.setState({ updateStartDate: e.target.value }) }}
                                // onChange={(e) => { this.setState({ startDate: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label>Stop Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStopDate}
                                onChange={(e) => { this.setState({ updateStopDate: e.target.value }) }}
                                // onChange={(e) => { this.setState({ stopDate: e.target.value }) }}
                            />
                        </div>
                    </div>
                </div>

                <div className={
                    classNames({
                        "custom-button small alt inline apply-changes": true,
                        "disabled": !(
                            this.state.updateStartDate !== this.state.startDate
                            || this.state.updateStopDate !== this.state.stopDate
                        )
                    })} 
                    onClick={this.applyChanges}
                >
                    <i className="fas fa-check" /> Apply Changes
                </div>


                <div className="custom-button small alt inline" onClick={this.reset}>
                    <i className="fas fa-redo-alt" /> Reset Filters
                </div>
                <br/>
                <br/>

                <div className="row-2">
                    <div className="measurements">
                        <div className="form-field">
                            <label>Measurement Type</label>
                        </div>
                        <FormFieldCheckbox
                            notSolid
                            label="All"
                            value={['unavailability', 'downloadPerformance', 'queryPerformance'].every((v) => _state[v])}
                            onChange={(val: boolean) => {
                                this.setState({
                                    unavailability: val,
                                    downloadPerformance: val,
                                    queryPerformance: val,
                                })
                                this.fetch_data();
                            }}
                        />
                        <FormFieldCheckbox
                            notSolid
                            label="unavailability"
                            value={this.state.unavailability}
                            onChange={(unavailability: boolean) => { 
                                this.setState({ unavailability });
                                if(unavailability) this.fetch_service_data('unavailability');
                            }}
                        />
                        <FormFieldCheckbox
                            notSolid
                            label="Download Performance"
                            value={this.state.downloadPerformance}
                            onChange={(downloadPerformance: boolean) => { 
                                this.setState({ downloadPerformance });
                                if(downloadPerformance) this.fetch_service_data('downloadPerformance');
                            }}
                        />
                        <FormFieldCheckbox
                            notSolid
                            label="Query Performance"
                            value={this.state.queryPerformance}
                            onChange={(queryPerformance: boolean) => { 
                                this.setState({ queryPerformance });
                                if(queryPerformance) this.fetch_service_data('queryPerformance');
                            }}
                        />
                    </div>

                    <div className="row-2">
                    </div>
                </div>

                <br />
                <br />

                {/* GRAPHS */}
                <div className="title-3">Results</div>

                <Tabs
                    tabs={[
                        {
                            label: <><i className="fas fa-chart-bar" /> Graph</>,
                            content: <div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                    <div className="centered">
                                        <Spinner />
                                    </div>
                                    :
                                    <>  
                                        <FormFieldCheckbox
                                            notSolid label="Drag Mode"
                                            value={!!this.state.drag_mode}
                                            onChange={(drag_mode: boolean) => { this.setState({ drag_mode }) }}
                                        />

                                        {/* UNAVAILABILITY */}
                                        {
                                            this.state.unavailability && this.state.unavailability_data &&
                                            <div className="kpi-graph kpi-3-graph">
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <Line
                                                    plugins={[zoomPlugin]}
                                                    options={{
                                                        ...default_options,
                                                        elements: {
                                                            line: {
                                                                tension: 0 // disables bezier curves
                                                            }
                                                        },
                                                        scales: {
                                                            xAxes: [{
                                                                type: 'time',
                                                                ticks: {
                                                                    ...default_options.scales.xAxes.ticks,
                                                                    min: moment(new Date(this.state.startDate)),
                                                                    max: moment(new Date(this.state.stopDate)),
                                                                },
                                                                time: {
                                                                    ...default_options.scales.xAxes.time,
                                                                },
                                                            }],
                                                            yAxes: [{
                                                                ticks: {
                                                                    min: 0,
                                                                    stepSize: 1,
                                                                    max: 1
                                                                },
                                                                scaleLabel: {
                                                                    ...default_options.scales.yAxes.scaleLabel,
                                                                    labelString: 'Availability / Unavailable',
                                                                }
                                                            }],
                                                        },

                                                        zoom: {
                                                            enabled: true,
                                                            onZoomComplete: this.on_zoom_complete,
                                                            drag: this.state.drag_mode,
                                                            wheel: !this.state.drag_mode,
                                                            mode: 'x',
                                                        },
                                                    }}
                                                    data={{
                                                        labels: ['availability'],
                                                        datasets: [
                                                            {
                                                                steppedLine: 'after',
                                                                label: 'availability',
                                                                borderColor: 'rgb(11, 206, 99)',
                                                                backgroundColor: 'rgb(11, 206, 99,0.1)',
                                                                data: this.state.unavailability_data.map((d: any) => {
                                                                    return { y: d.value, x: date_timezone_compensated(d.date_time)  };
                                                                })
                                                                
                                                                // data: [
                                                                //     complete_bar_data_stop(this.state.unavailability_data, 'value', this.state.stopDate),
                                                                //     ...this.state.unavailability_data.map((d: any) => {
                                                                //         return { y: d.value, x: date_timezone_compensated(d.date_time)  };
                                                                //     })
                                                                // ]
                                                            }
                                                        ]
                                                    }}
                                                />
                                            </div>
                                        }

                                        {/* DOWNLOAD PERFORMANCE */}
                                        {
                                            this.state.downloadPerformance && this.state.downloadPerformance_data &&
                                            <div className="kpi-graph kpi-3-graph">
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <Line
                                                    plugins={[ zoomPlugin ]}
                                                    options={{
                                                        ...default_options,
                                                        elements: {
                                                            line: {
                                                                tension: 0 // disables bezier curves
                                                            }
                                                        },
                                                        scales: {
                                                            xAxes: [{
                                                                type: 'time',
                                                                ticks: {
                                                                    ...default_options.scales.xAxes.ticks,
                                                                    min: moment(new Date(this.state.startDate)),
                                                                    max: moment(new Date(this.state.stopDate)),
                                                                },
                                                                time: {
                                                                    ...default_options.scales.xAxes.time,
                                                                },
                                                            }],
                                                            yAxes: [{
                                                                ticks: {
                                                                    min: 0
                                                                },
                                                                scaleLabel: {
                                                                    ...default_options.scales.yAxes.scaleLabel,
                                                                    labelString: `Download performance ${this.get_type_unit('download performance', true)}`,
                                                                }
                                                            }],
                                                        },

                                                        zoom: {
                                                            enabled: true,
                                                            onZoomComplete: this.on_zoom_complete,
                                                            drag: this.state.drag_mode,
                                                            wheel: !this.state.drag_mode,
                                                            mode: 'x',
                                                        },
                                                    }}
                                                    data={{
                                                        labels: ['Download Performance'],
                                                        datasets: [
                                                            {
                                                                label: 'Download Performance',
                                                                borderColor: 'rgb(238, 168, 128)',
                                                                backgroundColor: 'rgba(238, 168, 128, 0.1)',
                                                                data: this.state.downloadPerformance_data?.map((d: any) => {
                                                                    return { y: this.to_gb(d.value), x: date_timezone_compensated(d.date_time) };
                                                                })
                                                            }
                                                        ]
                                                    }}
                                                />
                                            </div>
                                        }

                                        {/* QUERY PERFORMANCE */}
                                        {
                                            this.state.queryPerformance && this.state.queryPerformance_data &&
                                            <div className="kpi-graph kpi-3-graph">
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <Line
                                                    plugins={[zoomPlugin]}
                                                    options={{
                                                        ...default_options,
                                                        elements: {
                                                            line: {
                                                                tension: 0 // disables bezier curves
                                                            }
                                                        },
                                                        scales: {
                                                            xAxes: [{
                                                                type: 'time',
                                                                ticks: {
                                                                    ...default_options.scales.xAxes.ticks,
                                                                    min: moment(new Date(this.state.startDate)),
                                                                    max: moment(new Date(this.state.stopDate)),
                                                                },
                                                                time: {
                                                                    ...default_options.scales.xAxes.time,
                                                                },
                                                            }],
                                                            yAxes: [{
                                                                ticks: {
                                                                    min: 0
                                                                },
                                                                scaleLabel: {
                                                                    ...default_options.scales.yAxes.scaleLabel,
                                                                    labelString: `Query performance ${this.get_type_unit('query performance', true)}`,
                                                                }
                                                            }],
                                                        },

                                                        zoom: {
                                                            enabled: true,
                                                            onZoomComplete: this.on_zoom_complete,
                                                            drag: this.state.drag_mode,
                                                            wheel: !this.state.drag_mode,
                                                            mode: 'x',
                                                        },
                                                    }}
                                                    data={{
                                                        labels: ['Query Performance'],
                                                        datasets: [
                                                            {
                                                                label: 'Query Performance',
                                                                borderColor: 'rgb(11, 128, 206)',
                                                                backgroundColor: 'rgba(11, 128, 206,0.1)',
                                                                data: this.state.queryPerformance_data.map((d: any) => {
                                                                    return { y: d.value, x: date_timezone_compensated(d.date_time) };
                                                                })
                                                            }
                                                        ]
                                                    }}
                                                />
                                            </div>
                                        }

                                    </>
                                }

                            </div>
                        },
                        {
                            label: <><i className="fas fa-th-list" /> Data</>,
                            content: <div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                    <div className="centered">
                                        <Spinner />
                                    </div>
                                    :
                                    <div className="relative">
                                        {
                                            this.state.unavailability && this.state.unavailability_data &&
                                            <KPITable title="Unavailability" counter={this.state.unavailability_data?.length}>
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <table className="table-kpi">
                                                    <thead>
                                                        <tr>
                                                            <th>Measurement type</th>
                                                            <th>Date</th>
                                                            <th>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.unavailability_data.map((d: any, key: number) => (
                                                                <tr key={key}>
                                                                    <td>{d.type}</td>
                                                                    <td>{d.date_time}</td>
                                                                    <td>{d.value}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </KPITable>
                                        }

                                        {
                                            this.state.downloadPerformance && this.state.downloadPerformance_data &&
                                            <KPITable title="Download Performance" counter={this.state.downloadPerformance_data?.length}>
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <table className="table-kpi">
                                                    <thead>
                                                        <tr>
                                                            <th>Measurement type</th>
                                                            <th>Date</th>
                                                            <th>Value {this.get_type_unit('download performance', true)}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.downloadPerformance_data.map((d: any, key: number) => (
                                                                <tr key={key}>
                                                                    <td>{d.type}</td>
                                                                    <td>{d.date_time}</td>
                                                                    <td>{d.value}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </KPITable>
                                        }

                                        {
                                            this.state.queryPerformance && this.state.queryPerformance_data &&
                                            <KPITable title="Query Performance" counter={this.state.queryPerformance_data?.length}>
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <table className="table-kpi">
                                                    <thead>
                                                        <tr>
                                                            <th>Measurement type</th>
                                                            <th>Date</th>
                                                            <th>Value {this.get_type_unit('query performance', true)}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.queryPerformance_data.map((d: any, key: number) => (
                                                                <tr key={key}>
                                                                    <td>{d.type}</td>
                                                                    <td>{d.date_time}</td>
                                                                    <td>{d.value}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </KPITable>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    ]}
                />




                <br />
                <br />
                {/* DOWNLOAD */}
                <div className="title-3">Export</div>
                <p>Export Data used to compute the KPI</p>

                <FormFieldCheckbox
                    notSolid label="JSON Format"
                    value={!!this.state.json_format}
                    onChange={(json_format: boolean) => { this.setState({ json_format }) }}
                />
                <a 
                    className={classNames({
                        "custom-button medium inline": true,
                        "disabled": !this.type_selected()
                    })}
                    href={this.download_url()} download
                >
                    <i className="fas fa-cloud-download-alt" /> Export
                </a>
            </KPIs>
        );
    }

    get_type_unit = (type:string, parentheses?:boolean) =>{
        return this.state.types?.[type]?.unit ?
                parentheses ? `(${this.state.types?.[type]?.unit})` : this.state.types?.[type]?.unit
            : '';
    }

    type_selected = () =>{
        return (this.state.downloadPerformance || this.state.queryPerformance || this.state.unavailability)
    }
    update_url = () =>{
        update_kpi_url(3, {
            startDate: to_local_iso_string(this.state.startDate),
            stopDate: to_local_iso_string(this.state.stopDate),
        })
    }

    on_zoom_complete = async(e: any) => {
        try {
            let start = getDateTimeString(new Date(e?.chart?.scales?.['x-axis-0']?.min), true, true);
            let stop = getDateTimeString(new Date(e?.chart?.scales?.['x-axis-0']?.max), true, true);
            await this.setState({
                startDate: start,
                stopDate: stop,
                updateStartDate: start,
                updateStopDate: stop
            })
            this.update_url()
            this.fetch_data()
        }
        catch (e) { }
    }

    to_gb = (num: number) => {
        return num;
        // return num / (Math.pow(1024, 3))
    }

    download_url = () => {
        let params = [
            // 'expand=product,sensing_product',
            'export=true',
            `start_date=${this.state.startDate}`,
            `stop_date=${this.state.stopDate}`
        ];

        let exports = [];
        if(this.state.unavailability) exports.push('unavailability');
        if(this.state.queryPerformance) exports.push('query performance');
        if(this.state.downloadPerformance) exports.push('download performance');
        if(exports.length > 0) params.push(`exports=${exports.join(',')}`);

        if(this.state.json_format) params.push('format=json');
        
        return `${API_URL}/api/v1/distribution?${params.join('&')}`
    }


};



export default connect((state:any)=>{
    return {
        kpi: state.kpi
    }
})(KPI3)